import { useIsNavigatingAway } from '@jane/bloom/hooks/navigation/useIsNavigating';
import { usePinStore } from '@jane/bloom/hooks/storeSwitcher/usePinStore';
import type {
  CommunicationBannerViewModel,
  ImageBannerViewModel,
  TextBannerViewModel,
} from '@jane/bloom/viewModels/communicationBanner';

import { ImageBanner } from './communicationBanner/imageBanner';
import { TextBanner } from './communicationBanner/textBanner';
import { CarouselSkeleton } from './skeletonLoaders/carouselSkeleton';

const isTextCommunicationBanner = (
  communicationBanner: CommunicationBannerViewModel
): communicationBanner is TextBannerViewModel =>
  communicationBanner?.banner_type === 'text';

const isImageCommunicationBanner = (
  communicationBanner: CommunicationBannerViewModel
): communicationBanner is ImageBannerViewModel =>
  communicationBanner?.banner_type === 'image';

export type CommunicationBannerProps = {
  communicationBanner: CommunicationBannerViewModel;
  showImageBanner: boolean;
};

export const CommunicationBanner = ({
  communicationBanner,
  showImageBanner,
}: CommunicationBannerProps) => {
  const { pinning: manuallyPinning } = usePinStore();
  const isNavigatingAway = useIsNavigatingAway();
  const shouldShowSkeleton = manuallyPinning || isNavigatingAway;

  if (isTextCommunicationBanner(communicationBanner)) {
    if (shouldShowSkeleton) {
      return null;
    }
    return <TextBanner communicationBanner={communicationBanner} />;
  }
  if (isImageCommunicationBanner(communicationBanner) && showImageBanner) {
    if (shouldShowSkeleton) {
      return <CarouselSkeleton mode="image-banner" />;
    }
    return <ImageBanner communicationBanner={communicationBanner} />;
  }
  return null;
};
